const firebaseConfig = {
    apiKey: "AIzaSyANr1Wh3ZW5RvTW7CXM8Osz2rTAG7T_KBM",
    authDomain: "health-care-system-d5cf1.firebaseapp.com",
    projectId: "health-care-system-d5cf1",
    storageBucket: "health-care-system-d5cf1.appspot.com",
    messagingSenderId: "364191361975",
    appId: "1:364191361975:web:f9a033d3992017c6555632"
};
export default firebaseConfig;